import React from 'react';
import { getContext } from 'common';

import Styled from './styles';

export interface DialogFooterProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the footer */
  children: React.ReactNode;
}

/** All other props will be provided to the wrapper element. */
const DialogFooter = React.forwardRef<HTMLElement, DialogFooterProps>((props: DialogFooterProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    ...otherProps
  } = props;
  return (
    <Styled.Footer
      ref={ref}
      RTL={RTL}
      {...otherProps}
    >
      {children}
    </Styled.Footer>
  );
}));

DialogFooter.displayName = 'DialogFooter';

export default DialogFooter;
